// extracted by mini-css-extract-plugin
export var backdropBlur = "_mp-0";
export var contentCard = "_mp-5";
export var frame = "_mp-2";
export var image = "_mp-4";
export var imagePane = "_mp-3";
export var modal = "_mp-1";